import { useIsFetching } from '@tanstack/react-query'

import { HeaderConfigBar } from '@fortem-monorepo/react-spa'
import type { AccruedInterests } from '@fortem-monorepo/web-sdk'

import { isFutureBalanceDate } from '@/lib/accrued-interest-dates'
import { accruedInterestKeys } from '@/react-query/queries/accrued-interests'

import { useAccruedInterestActions } from '../AccruedInterestActions.context'
import { useAccruedInterestsContext } from '../AccruedInterests.context'
import { AccruedChartInstrumentFilter } from './AccruedChartInstrumentFilter'
import { AccruedInterestFilters } from './AccruedInterestFilters'

export const AccruedInterestToolbar = () => {
  const { params, setParams, balanceDrafts, clearDrafts, activeTab } = useAccruedInterestsContext()
  const actions = useAccruedInterestActions()
  const fetching = useIsFetching({ queryKey: accruedInterestKeys.all }) > 0
  const changeScope = (next: AccruedInterests.Params) => {
    if (actions.actionState || fetching) return
    if (activeTab === 'balances' && isFutureBalanceDate(next.value_date)) return
    if (next.fund_name === params.fund_name && next.value_date === params.value_date) return
    if (!Object.keys(balanceDrafts).length) {
      setParams(next)
      return
    }
    actions.openDiscardDrafts({
      description: `Change the selected fund or date for ${params.fund_name} on ${params.value_date}.`,
      onDiscard: () => {
        clearDrafts(params)
        setParams(next)
      },
    })
  }
  return (
    <HeaderConfigBar className="shrink-0 flex-wrap items-end gap-4">
      <AccruedInterestFilters
        params={params}
        onChange={changeScope}
        disabled={fetching || !!actions.actionState}
        showDate={activeTab !== 'chart'}
        limitToToday={activeTab === 'balances'}
      />
      {activeTab === 'chart' && <AccruedChartInstrumentFilter disabled={fetching || !!actions.actionState} />}
    </HeaderConfigBar>
  )
}
